import SubscriptionsTabLayout from "./SubscriptionsTabLayout";
import CommonTable from "../CommonTable/CommonTable";
import {useEffect, useMemo, useState} from "react";
import Select from "react-select";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import makeAnimated from 'react-select/animated';
import useSubscriptionPeriods from "./useSubscriptionPeriods";
import moment from "moment";
import invoiceService from "../../services/invoice.service";

const ServiceSubscriptionsTab = ({ id, onFilterChange }) => {
    const monitoringOnlyId = 3;
    const freeEntryStatusId = 3;
    const animatedComponents = makeAnimated();

    const subscriptionOptions = [
        {
            value: -1,
            label: 'All'
        },
        {
            value: 0,
            label: '1 Year'
        },
        {
            value: 1,
            label: '2 Year'
        },
        {
            value: 2,
            label: '3 Year'
        }
    ];

    const showingOptions = [
        {
            value: 'Active',
            label: 'Active'
        },
        {
            value: 'Early Terminations',
            label: 'Early Terminations'
        },
        {
            value: 'Both',
            label: 'Both'
        }
    ];

    let total = {
        oneYr: 0,
        twoYr: 0,
        threeYr: 0,
        zeroToOneYr: 0,
        oneToTwoYr: 0,
        twoToThreeYr: 0
    };
    
    const periods = useSubscriptionPeriods();
    const [selectedPeriod, setSelectedPeriod] = useState(null);
    const [subscription, setSubscription ] = useState(subscriptionOptions[0]);
    const [quit, setQuit ] = useState(subscriptionOptions[0]);
    const [showing, setShowing ] = useState(showingOptions[0]);
    const [summary, setSummary ] = useState(total);
    const [mappedData, setMappedData] = useState([]);
    const [loading, setLoading] = useState(true);

    const getRemainingContractLength = (planId, end, start) => {
        if (planId >= 0 && planId <= 2){
            if(end === null){
                end = new Date();
            }
            let endDate = moment(end);
            let startDate = moment(start);
            let totalMonths = endDate.diff(startDate, 'months');
            let years = Math.floor(totalMonths / 12);
            let months = totalMonths % 12;
            let result = "";
            if (years > 0) {
                result += years + (years === 1 ? " Year" : " Years");
            }
            if (months > 0) {
                if (years > 0) {
                    result += ", ";
                }
                result += months + (months === 1 ? " Month" : " Months");
            }
            return result;
        }
        return 0;
    }

    const getEndDate = (planId, start) => {
        switch (planId) {
            case 0:
                return moment(start).add(1, 'years').toDate();
            case 1:
                return moment(start).add(2, 'years').toDate();
            case 2:
                return moment(start).add(3, 'years').toDate();
            case 3:
                return moment(start).add(20, 'years').toDate();
             default:
                 return null;
        }
    }
    
    useEffect(() => {
        if (periods.length === 0) return;
            setSelectedPeriod(prev => prev ?? periods[0]);
    }, [periods]);

    useEffect(() => {
        if (!selectedPeriod) return;
        //filter by period
        let dateRange = selectedPeriod.value.split('-');
        let star = dateRange[0].trim();
        let end = dateRange[1].trim();
        const fetchDataAsync = async () => {
            setLoading(true);
            try {
                let response = await invoiceService.full(id, star, end);
                let invoiceDate = response.invoiceDate;
                let customers = response.customers;
                let mappedData = customers.flatMap(customer=>(customer.billingSubscriptions || []).map(sub=>({
                    deviceId:sub.deviceId,
                    name: customer.customerName,
                    address: customer.address,
                    start: moment(sub.start).calendar(),
                    duration: sub.planId >= 0 && sub.planId <= 2 ? (sub.planId + 1): 0,
                    remaining: getRemainingContractLength(sub.planId, sub.terminationDate === null ? getEndDate(sub.planId, sub.start) : sub.terminationDate, sub.terminationDate === null ? invoiceDate : sub.start),
                    planId: sub.planId,
                    end: sub.terminationDate === null ? null: moment(sub.terminationDate).calendar(),
                    isLpx: sub.isLpx,
                    quitLengthClassificationId: sub.quitLengthClassificationId
                })));
                setMappedData(mappedData);
            }finally {
                setLoading(false);
            }
        };

        fetchDataAsync().catch(error => {});

    }, [id, selectedPeriod]);
    
    const onContractLengthClick = (selected)=>{
        setShowing(showingOptions[0]);
        setSubscription(selected);
    }
    const onEarlyTerminationsClick = (selected)=>{
        setShowing(showingOptions[1]);
        setSubscription(subscriptionOptions[0]);
        setQuit(selected)
        
    }
    const getActiveByPeriod = (filtered, invoicePeriodEndDate, filter) =>{
        //filter by subscription length
        filtered = filtered.filter(o=>(o.end === null || new Date(o.end)  > invoicePeriodEndDate) && o.planId !== monitoringOnlyId);
        if (filter === -1){
            filtered = filtered.filter(s => s.planId >= 0 && s.planId <= 2);
        }
        else {
            filtered = filtered.filter(s => s.planId === filter);
        }
        return filtered;
    }
    const earlyTerminationSubscriptionsByPeriod = (filtered, invoicePeriodEndDate, filter) => {
        if (filter !== undefined && filter !== null && !isNaN(filter) && !isNaN(parseFloat(filter))){
            switch(filter) {
                case -1:
                    filtered = filtered.filter(o=>!o.isLpx && o.planId !== monitoringOnlyId && o.quitLengthClassificationId !== null && new Date(o.end) <= invoicePeriodEndDate);
                    break;
                case 0:
                    filtered = filtered.filter(s => !s.isLpx && s.planId !== monitoringOnlyId && s.quitLengthClassificationId === 0 && new Date(s.end) <= invoicePeriodEndDate);
                    break;
                case 1:
                    filtered = filtered.filter(s => !s.isLpx && s.planId !== monitoringOnlyId && s.quitLengthClassificationId === 1 && new Date(s.end)<= invoicePeriodEndDate);
                    break;
                case 2:
                    filtered = filtered.filter(s => !s.isLpx && s.planId !== monitoringOnlyId && s.quitLengthClassificationId === 2 && new Date(s.end) <= invoicePeriodEndDate);
                    break;
                default:
                    filtered = filtered.filter(o=>o.planId === monitoringOnlyId && o.quitLengthClassificationId !== null && new Date(o.end) <= invoicePeriodEndDate);
            }
        }
        else {
            filtered = filtered.filter(o=>o.end !== null && new Date(o.end) <= invoicePeriodEndDate);
        }

        return filtered;
    }
    const getSummary = (data, invoicePeriodEndDate) => {
        if (data.length) {
            total.oneYr = data.filter(s => s.planId === 0 && (s.end === null || new Date(s.end)  > invoicePeriodEndDate)).length;
            total.twoYr = data.filter(s => s.planId === 1 && (s.end === null || new Date(s.end)  > invoicePeriodEndDate)).length;
            total.threeYr = data.filter(s => s.planId === 2 && (s.end === null || new Date(s.end)  > invoicePeriodEndDate)).length;

            total.zeroToOneYr = data.filter(s => !s.isLpx && s.planId !== monitoringOnlyId && s.quitLengthClassificationId === 0 && new Date(s.end) <= invoicePeriodEndDate).length;
            total.oneToTwoYr = data.filter(s => !s.isLpx && s.planId !== monitoringOnlyId && s.quitLengthClassificationId === 1 && new Date(s.end) <= invoicePeriodEndDate).length;
            total.twoToThreeYr = data.filter(s => !s.isLpx && s.planId !== monitoringOnlyId && s.quitLengthClassificationId === 2 && new Date(s.end) <= invoicePeriodEndDate).length;

            setSummary(total);
        }
    }
    const data = useMemo(() => {
        if (!selectedPeriod) return;
        //filter by period
        let dateRange = selectedPeriod.value.split('-');
        let star = dateRange[0].trim();
        let end = dateRange[1].trim();
        let endDate = new Date(end);
        let filtered = [...mappedData];
        getSummary(filtered, endDate);
        //filtering active or terminated
        if (showing.value === "Active") {
            filtered = getActiveByPeriod(filtered, endDate, subscription.value);
        } else if (showing.value === "Early Terminations") {
            filtered = earlyTerminationSubscriptionsByPeriod(filtered, endDate, quit);
        } else {
            let active = getActiveByPeriod(filtered, endDate, subscription.value);
            let canceled = earlyTerminationSubscriptionsByPeriod(filtered, endDate, quit);
            filtered = active.concat(canceled);
        }
        onFilterChange(filtered);
        return filtered;
    }, [mappedData, subscription, showing]);
    let filters =
        <div className="alerts-tab-wrapper alerts-tab-top-wrapper">
            <div className="row no-gutters pad-left-40 margin-5">
                <div className="alerts-tab-options">
                    &nbsp; Billing Date: &nbsp;&nbsp;
                    <span className="min-width-200 margin-right-20">
                            <Select
                                closeMenuOnSelect={true}
                                components={animatedComponents}
                                options={periods}
                                onChange={setSelectedPeriod}
                                defaultValue={selectedPeriod}
                                value={selectedPeriod}
                            />
                        </span>

                    &nbsp; Subscription Length: &nbsp;&nbsp;
                    <span className="min-width-200 margin-right-20">
                            <Select
                                closeMenuOnSelect={true}
                                components={animatedComponents}
                                options={subscriptionOptions}
                                onChange={setSubscription}
                                defaultValue={subscriptionOptions[0]}
                                value={subscription}
                            />
                        </span>

                    &nbsp; Showing: &nbsp;&nbsp;
                    <span className="min-width-200 margin-right-20">
                            <Select
                                closeMenuOnSelect={true}
                                components={animatedComponents}
                                options={showingOptions}
                                onChange={setShowing}
                                defaultValue={showingOptions[0]}
                                value={showing}
                            />
                        </span>
                    <button className="secondary-btn btn-small" onClick={()=>{setSubscription(subscriptionOptions[0]); setShowing(showingOptions[0]);}}>Show All</button>
                </div>
            </div>
        </div>;

    let summaryComponent =
        <div className="alerts-tab-wrapper alerts-top-tabs">

            <div className="row no-gutters margin-top-15">
                <div className="col-2">
                    <h6 className="pad-left-15">Summary</h6>
                </div>
                <div className="col-3 justify-content-right">
                    <Card elevation={0}>
                        <CardContent className="pad-unset">
                            <h6 className="text-center">Contract Length</h6>
                            <div className="row no-gutters card-row  text-center font-size-80p margin-top-12 margin-bottom-15">

                                <div className="col-4 dashboard-val" onClick={()=>onContractLengthClick(subscriptionOptions[1])}>
                                    <div className="dashboard-number margin-bottom-4">
                                        {summary.oneYr}
                                    </div>
                                    <span className="color-dimgray">1 Year</span>
                                </div>

                                <div className="col-4 border-left-lightGray border-right-lightGray">
                                    <div className="dashboard-val" onClick={()=>onContractLengthClick(subscriptionOptions[2])}>
                                        <div className="dashboard-number margin-bottom-4">
                                            {summary.twoYr}
                                        </div>
                                        <span className="color-dimgray">2 Year</span>
                                    </div>
                                </div>

                                <div className="col-4 dashboard-val" onClick={()=>onContractLengthClick(subscriptionOptions[3])}>
                                    <div className="dashboard-number margin-bottom-4">
                                        {summary.threeYr}
                                    </div>
                                    <span className="color-dimgray">3 Year</span>
                                </div>

                            </div>
                        </CardContent>
                    </Card>
                </div>

                <div className="col-3 offset-1 justify-content-left">
                    <Card elevation={0}>
                        <CardContent className="pad-unset">
                            <h6 className="text-center">Early Terminations</h6>
                            <div className="row no-gutters card-row text-center font-size-80p margin-top-12 margin-bottom-15">
                                <div className="col-4 dashboard-val" onClick={()=>onEarlyTerminationsClick(0)}>
                                    <div className="dashboard-number margin-bottom-4">
                                        {summary.zeroToOneYr}
                                    </div>
                                    <span className="color-dimgray">0-1 Year</span>
                                </div>

                                <div className="col-4 border-left-lightGray border-right-lightGray">
                                    <div className="dashboard-val" onClick={()=>onEarlyTerminationsClick(1)}>
                                        <div className="dashboard-number margin-bottom-4">
                                            {summary.oneToTwoYr}
                                        </div>
                                        <span className="color-dimgray">1-2 Year</span>
                                    </div>
                                </div>

                                <div className="col-4 dashboard-val" onClick={()=>onEarlyTerminationsClick(2)}>
                                    <div className="dashboard-number margin-bottom-4">
                                        {summary.twoToThreeYr}
                                    </div>
                                    <span className="color-dimgray">2-3 Year</span>
                                </div>

                            </div>
                        </CardContent>
                    </Card>
                </div>
            </div>
        </div>;

    let columns = [
        {field: 'deviceId', header: 'DEVICE ID'},
        {field: 'name', header: 'NAME'},
        {field: 'address', header: 'ADDRESS'},
        {field: 'start', header: 'CONTRACT START DATE'},
        {field: 'duration', header: 'CONTRACT LENGTH'},
        {field: 'remaining', header: 'REMAINING CONTRACT LENGTH FROM TODAY'},
        
    ];
    if(showing.value !== showingOptions[0].value) {
        columns.push({field: 'end', header: 'TERMINATION DATE'})
    }
    
    return (
        <SubscriptionsTabLayout 
            filters={filters}
            summary={summaryComponent}
            table={
                <div className="margin-20-30">
                    <div className="justify-content-center">
                        <CommonTable columns={columns} data={data ?? []} loading = {loading}/>
                    </div>
                </div>}
            />
    );
}

export default ServiceSubscriptionsTab;